import React from 'react';
import { Router, IndexRoute, Route } from 'react-router';
import App from './components/app';
import Home from './components/pages/home/Home';
import Dashboard from './components/pages/home/Dashboard';
import Reporting from './components/pages/reporting/Reporting';
import SignInPage from './components/pages/signin/SignInPage';
import SignUpPage from './components/pages/signup/SignUpPage';
import ProfilePage from './components/pages/profile/ProfilePage';
import EditProfilePage from './components/pages/profile/EditProfilePage';
import ResetPwdForm from './components/pages/resetpassword/ResetPasswordForm';
import ClubsPage from './components/pages/club/ClubsPage';
import ClubPage from './components/pages/club/ClubPage';
import MembersPage from './components/pages/club/MembersPage';
import MemberPage from './components/pages/club/MemberPage';
import PigeonHolePage from './components/pages/club/PigeonHolePage';
import SectionsPage from "./components/pages/section/SectionsPage";
import SectionPage from "./components/pages/section/SectionPage";
import RacesPage from './components/pages/race/RacesPage';
import RacePage from './components/pages/race/RacePage';
import StationsPage from './components/pages/lists/StationsPage';
import RangesPage from './components/pages/lists/RangesPage';
import ZipCodesPage from "./components/pages/lists/ZipCodesPage";
import NightTimesPage from "./components/pages/lists/NightTimesPage";
import DerbysPage from "./components/pages/lists/DerbysPage";
import ErrorListsPage from "./components/pages/errorLists/ErrorListsPage";
import SettingsPage from "./components/pages/settings/SettingsPage";
import ChampionshipsPage from "./components/pages/championships/ChampionshipsPage";
import ChampionshipPage from "./components/pages/championships/ChampionshipPage";

import { requireAuthentication } from './components/misc/requireauth';

import {
    ROUTE_APP, ROUTE_SIGNIN, ROUTE_SIGNUP, ROUTE_RESET_PASSWORD,
    ROUTE_PROFILE, ROUTE_PROFILE_CURRENT, ROUTE_EDIT_PROFILE, ROUTE_EDIT_PROFILE_CURRENT,
    ROUTE_DASHBOARD, ROUTE_REPORTING,
    ROUTE_CLUB, ROUTE_CLUBS, ROUTE_MEMBERS, ROUTE_MEMBER, ROUTE_PIGEON_HOLE,
    ROUTE_RACES, ROUTE_RACE,
    ROUTE_STATIONS, ROUTE_RANGES, ROUTE_ZIPS, ROUTE_NIGHT_TIMES, ROUTE_DERBYS, ROUTE_SECTIONS, ROUTE_SECTION,
    ROUTE_ERROR_LISTS, ROUTE_SETTINGS, ROUTE_CHAMPIONSHIPS, ROUTE_CHAMPIONSHIP
} from './constants/routeconstants';


export default function (history) {
    return (
        <Router history={history}>
            <Route path={ROUTE_APP} component={App}>
                {/*<IndexRoute component={requireAuthentication(Home)} />*/}
                <IndexRoute component={requireAuthentication(Home)} />
                <Route path={ROUTE_SIGNIN} component={SignInPage} />
                <Route path={ROUTE_DASHBOARD} component={requireAuthentication(Dashboard)} />
                <Route path={ROUTE_REPORTING} component={requireAuthentication(Reporting)} />
                <Route path={ROUTE_CLUBS} component={requireAuthentication(ClubsPage)} />
                <Route path={ROUTE_CLUB} component={requireAuthentication(ClubPage)} />
                <Route path={ROUTE_MEMBERS} component={requireAuthentication(MembersPage)} />
                <Route path={ROUTE_MEMBER} component={requireAuthentication(MemberPage)} />
                <Route path={ROUTE_PIGEON_HOLE} component={requireAuthentication(PigeonHolePage)} />
                <Route path={ROUTE_SECTIONS} component={requireAuthentication(SectionsPage)} />
                <Route path={ROUTE_SECTION} component={requireAuthentication(SectionPage)} />
                <Route path={ROUTE_RACES} component={requireAuthentication(RacesPage)} />
                <Route path={ROUTE_RACE} component={requireAuthentication(RacePage)} />
                <Route path={ROUTE_STATIONS} component={requireAuthentication(StationsPage)} />
                <Route path={ROUTE_RANGES} component={requireAuthentication(RangesPage)} />
                <Route path={ROUTE_ZIPS} component={requireAuthentication(ZipCodesPage)} />
                <Route path={ROUTE_NIGHT_TIMES} component={requireAuthentication(NightTimesPage)} />
                <Route path={ROUTE_DERBYS} component={requireAuthentication(DerbysPage)} />
                <Route path={ROUTE_ERROR_LISTS} component={requireAuthentication(ErrorListsPage)} />
                <Route path={ROUTE_SETTINGS} component={requireAuthentication(SettingsPage)} />
                <Route path={ROUTE_CHAMPIONSHIPS} component={requireAuthentication(ChampionshipsPage)} />
                <Route path={ROUTE_CHAMPIONSHIP} component={requireAuthentication(ChampionshipPage)} />
                {/*<Route path={ROUTE_SIGNUP} component={SignUpPage} />
                <Route path={ROUTE_PROFILE} component={ProfilePage} />
                <Route path={ROUTE_PROFILE_CURRENT} component={requireAuthentication(ProfilePage)} />
                <Route path={ROUTE_EDIT_PROFILE} component={requireAuthentication(EditProfilePage)} />
                <Route path={ROUTE_EDIT_PROFILE_CURRENT} component={requireAuthentication(EditProfilePage)} />
                <Route path={ROUTE_RESET_PASSWORD} component={ResetPwdForm} />*/}
            </Route>
        </Router>
    );
}



// WEBPACK FOOTER //
// ./src/client/src/approute.js